import { useCallback } from "react";
import { affordances } from "../util/analytics";

export const useTables = ({ tablesContent, setTableData, setIsDialogOpen }) => {
  const openTableById = useCallback(
    (tableId, tableTitle) => {
      setTableData({
        isStandAlone: true,
        title: tableTitle,
        tableId,
        children: tablesContent[tableId],
        affordance: affordances.TABLE_FIND_IN_TOPIC,
      });
      setIsDialogOpen(true);
    },
    [tablesContent, setIsDialogOpen, setTableData]
  );

  return { openTableById };
};
